<template>
    <div class="loading-bar"></div>
</template>

<script>
export default {
    name: 'LoadingBar'
};
</script>

<style lang="scss" scoped>
//TODO make a separate dark & light background version.
.loading-bar {
    height: 1rem;
    width: 100%;

    border-radius: $card-border-radius;
    background: $gray-100;
    background: linear-gradient(90deg, rgba($gray-100, 0.9), rgba($gray-100, 0.9), rgba(darken($gray-500, 5%),0.9), rgba($gray-100, 0.9), rgba($gray-100, 0.9)); //For dark backgrounds only.

    //A couple other colorful options that may be useful in other contexts.
    //background: linear-gradient(90deg, $secondary, $dark, $secondary);
    //background: linear-gradient(90deg, $white, $white, $primary, $white, $white);

    background-size: 200%;
    animation: overlay 1.5s linear infinite;
}

@keyframes overlay {
    0% {
        background-position: 0;
    }
    50% {
        background-position: 100%;
    }
    100% {
        background-position: 0;
    }
}

</style>